export const COUNTRY_CODES = [
  'BE',
  'DE',
  'ES',
  'FR',
  'IE',
  'IT',
  'NL',
  'PT',
  'UN',
];



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/packlink_supported_countries.ts